import React, { useState, useEffect } from 'react';

const QuizComponent = ({ question, selectedOption: initialSelectedOption, onComplete, questionNumber }) => {
  const [selectedOption, setSelectedOption] = useState(initialSelectedOption || '');

  useEffect(() => {
    setSelectedOption(initialSelectedOption || '');
  }, [initialSelectedOption]);

  if (!question || typeof question.title !== 'string') {
    console.error('Question or title is undefined or not a string:', question);
    return <div>No valid question available.</div>;
  }

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    onComplete(selectedValue, question.id);
  };

  return (
    <div>
      <h5 className="font-bold mt-10">{`${questionNumber}. ${question.title}`}</h5>
      <fieldset>
        <legend>{question.question}</legend>
        {question.options.map((option, index) => (
          <label key={index} style={{ display: 'block', margin: '10px 0' }}>
            <input
              type="radio"
              name={`answer-${question.id}`}
              value={option}
              checked={selectedOption === option}
              onChange={handleOptionChange}
            />
                       <span className="ml-3">{`${String.fromCharCode(97 + index)}. ${option}`}</span>

          </label>
        ))}
      </fieldset>
    </div>
  );
};

export default QuizComponent;
